import {
  BEAR_CATEGORY,
  S3_BUCKET_URL,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
} from '@/constants';

import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';

import { ScreenAboutLook } from './screens/AboutLook';
import { ScreenAge } from './screens/Age';
import { ScreenBodyShape } from './screens/BodyShape';
import { BODY_SHAPE_OPTIONS } from './screens/BodyShape/BODY_SHAPE_OPTIONS';
import { ScreenCommunicate } from './screens/Communicate';
import { ScreenEmail } from './screens/Email';
import { ScreenEthnicity } from './screens/Ethnicity';
import { ScreenFindAi } from './screens/FindAi';
import { ScreenInteraction } from './screens/Interaction';
import { ScreenMajorTurnOff } from './screens/MajorTurnOff';
import { ScreenObedience } from './screens/Obedience';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { LayoutDataType } from './types';

export const layoutSteps = {
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  find_ai: {
    component: ScreenFindAi,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/layout-own-ai-man/body_shape/${option.id}.png`,
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man/bg-about-look.png`],
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man/modal_send_photos.png`],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  age: null,
  ethnicity: null,
  body_shape: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};

export const HARDCODED_CATEGORIES = [
  BEAR_CATEGORY,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
];
